import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo } from 'react';
import { Inline } from '@atlaskit/primitives';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { SmartLinkSize } from '../../../../../../../../constants';
import extractFlexibleUiContext from '../../../../../../../../extractors/flexible';
import Icon from '../../../../../elements/icon';
import Link from '../../../../../elements/link';
import { fireLinkClickedEvent } from '../../../../../../../../utils/analytics/click';
var RelatedUrlItem = function RelatedUrlItem(_ref) {
  var results = _ref.results,
    renderers = _ref.renderers,
    testId = _ref.testId;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var flexibleDataContext = useMemo(function () {
    return extractFlexibleUiContext({
      response: results,
      renderers: renderers
    });
  }, [renderers, results]);
  var onClick = useCallback(function (event) {
    fireLinkClickedEvent(createAnalyticsEvent)(event);
  }, [createAnalyticsEvent]);
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.050",
    testId: testId
  }, /*#__PURE__*/React.createElement(Icon, _extends({}, flexibleDataContext === null || flexibleDataContext === void 0 ? void 0 : flexibleDataContext.linkIcon, {
    testId: "".concat(testId, "-icon"),
    size: SmartLinkSize.Small
  })), /*#__PURE__*/React.createElement(Link, {
    testId: "".concat(testId, "-link"),
    text: flexibleDataContext === null || flexibleDataContext === void 0 ? void 0 : flexibleDataContext.title,
    url: flexibleDataContext === null || flexibleDataContext === void 0 ? void 0 : flexibleDataContext.url,
    size: SmartLinkSize.Small,
    maxLines: 1,
    onClick: onClick
  }));
};
export default RelatedUrlItem;